// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { ApiKeyAuth, OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let SurveyV2Api = class SurveyV2Api {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'ApiKey': new ApiKeyAuth('header', 'x-apikey'),
            'trialcard-poc.auth0.com': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'trialcard-test.auth0.com': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'Bearer': new ApiKeyAuth('header', 'Authorization'),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @param surveyId generated
     * @param xTcScopeid generated
     * @param xTcScopetype generated
     */
    async fullSurveyGet(surveyId, xTcScopeid, xTcScopetype) {
        const _url_ = '/survey/v2/FullSurvey';
        let _params_ = {};
        let _headers_ = {};
        if (surveyId !== undefined) {
            _params_['surveyId'] = Serializer.serialize(surveyId, "string");
        }
        _headers_['x-tc-scopeid'] = Serializer.serialize(xTcScopeid, "string");
        _headers_['x-tc-scopetype'] = Serializer.serialize(xTcScopetype, "string");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        return response;
    }
    /**
     *
     * @param xTcScopeid generated
     * @param xTcScopetype generated
     * @param fullSurveySessionByIdsPostRequest
     */
    async fullSurveySessionByIdsCreate2(xTcScopeid, xTcScopetype, fullSurveySessionByIdsPostRequest) {
        const _url_ = '/survey/v2/FullSurveySessionByIds';
        let _params_ = {};
        let _headers_ = {};
        _headers_['x-tc-scopeid'] = Serializer.serialize(xTcScopeid, "string");
        _headers_['x-tc-scopetype'] = Serializer.serialize(xTcScopetype, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(fullSurveySessionByIdsPostRequest, "FullSurveySessionByIdsPostRequest"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "object");
        }
        return response;
    }
    /**
     *
     * @param xTcScopeid generated
     * @param xTcScopetype generated
     * @param fullSurveySessionPostRequest
     */
    async fullSurveySessionCreate2(xTcScopeid, xTcScopetype, fullSurveySessionPostRequest) {
        const _url_ = '/survey/v2/FullSurveySession';
        let _params_ = {};
        let _headers_ = {};
        _headers_['x-tc-scopeid'] = Serializer.serialize(xTcScopeid, "string");
        _headers_['x-tc-scopetype'] = Serializer.serialize(xTcScopetype, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(fullSurveySessionPostRequest, "FullSurveySessionPostRequest"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "object");
        }
        return response;
    }
    /**
     *
     * @param id generated
     * @param xTcScopeid generated
     * @param xTcScopetype generated
     */
    async fullSurveySessionGet3(id, xTcScopeid, xTcScopetype) {
        const _url_ = '/survey/v2/FullSurveySession/{id}'
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'id' is not null or undefined
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling fullSurveySessionGet3.');
        }
        _headers_['x-tc-scopeid'] = Serializer.serialize(xTcScopeid, "string");
        _headers_['x-tc-scopetype'] = Serializer.serialize(xTcScopetype, "string");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "object");
        }
        return response;
    }
    /**
     *
     * @param xTcScopeid generated
     * @param xTcScopetype generated
     * @param surveySessionValuePostRequest
     */
    async sessionValueCreate2(xTcScopeid, xTcScopetype, surveySessionValuePostRequest) {
        const _url_ = '/survey/v2/SessionValue';
        let _params_ = {};
        let _headers_ = {};
        _headers_['x-tc-scopeid'] = Serializer.serialize(xTcScopeid, "string");
        _headers_['x-tc-scopetype'] = Serializer.serialize(xTcScopetype, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(surveySessionValuePostRequest, "SurveySessionValuePostRequest"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "object");
        }
        return response;
    }
    /**
     *
     * @param xTcScopeid generated
     * @param xTcScopetype generated
     * @param surveySessionPostRequest
     */
    async surveySessionCreate2(xTcScopeid, xTcScopetype, surveySessionPostRequest) {
        const _url_ = '/survey/v2/SurveySession';
        let _params_ = {};
        let _headers_ = {};
        _headers_['x-tc-scopeid'] = Serializer.serialize(xTcScopeid, "string");
        _headers_['x-tc-scopetype'] = Serializer.serialize(xTcScopetype, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(surveySessionPostRequest, "SurveySessionPostRequest"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "object");
        }
        return response;
    }
};
SurveyV2Api = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], SurveyV2Api);
export { SurveyV2Api };
//# sourceMappingURL=surveyV2Api.js.map